import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LargeIconButton = ({ icon, primaryTitle, secondaryTitle, onClick,  ...props }) => {
    const theme = useTheme();
    return (
        <Button
            onClick={onClick}
            {...props}
            sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start", 
                textAlign: "left",
                width: "100%", 
                padding: theme.spacing(1.5),
                gap: theme.spacing(1.5), 
                ...props.sx,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                }}
            >
                {icon}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                    variant="subtitle1"
                    component="span"
                    sx={{
                        fontWeight: "bold",
                        lineHeight: 1.2,
                    }}
                >
                    {primaryTitle}
                </Typography>
                <Typography
                    variant="caption"
                    component="span"
                    sx={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.2,
                        mt: theme.spacing(0.4),
                        textTransform: "none"
                    }}
                >
                    {secondaryTitle}
                </Typography>
            </Box>
        </Button>
    );
};

export default LargeIconButton;